import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import UserStore from '../../util/UserStore';
import $ from 'jquery';

var fpServerResponses = {
	200: 'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',
	403: 'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',
	600: 'Invalid User ID / Email / Mobile no.', // also for 400, 401
	0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'
  };

class MobileForgotPWD extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {	
			username_newacc: '',
			password_newacc: '',
			confirmpassword_newacc: '',
			singupType:"userid",
			loginType:this.props.loginType || "mobile",
			userInput:this.props.userInput || "",
			otp_newacc: '',				
			submitButtonDisabled: false,
			serverMessage: "",
			emailfeedbackmsg: "",
			source:"plp",
			isOTPSend:false,
			isVerified:false,
			OTPDisabled:"hiddenOTP",
			verifyDisabled:"disabled",
			emailDisabled:false,
			phoneDisabled:false,
			verifyText:this.rb("mobile.submit"),
			sendOTPText:this.rb("register.sendOTP"),
			passcodeDisabled:"disabled",
			selectedRole:"STU",
            resetSuccess:false,
            passwordType:"password",
            confirmPasswordType:"password",
		};
		
		this.classesTeaching = null;
		//this.selectedRole = null;
		this.userReferal = null;

		this.navigationKey="PLP_Navigation";

		this.handleChange = this.handleChange.bind(this);		
		this.enterOTPChange = this.enterOTPChange.bind(this);
		this.userIdChange = this.userIdChange.bind(this);

		this.getOTPField = this.getOTPField.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);

		this.myTrackerInstance = this.getTracker();
		
		this.gaFrom = this.props.gaFrom;
		//console.log("this.gaFrom:::::::::::",this.gaFrom);
		if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
			this.gaFrom = this.gaFrom+" Home - Join";
		}else{
			this.gaFrom = "Users who have independently registered - Sign Up";
		}
		//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
	}

	  componentWillReceiveProps(nextProps) {
	  	var me = this;

	  	this.gaFrom = nextProps.gaFrom;
	  	//console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
	  		this.gaFrom = this.gaFrom+" Home - Join";
	  	}else{
	  		this.gaFrom = "Users who have independently registered - Sign Up";
	  	}

	  	//console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	//console.log('componentWillReceiveProps', nextProps);    
	  	this.setState({	
	  		loginType:nextProps.loginType || "mobile",
	  		userInput:nextProps.userInput || "",
	  		otp_newacc: '',				
	  		submitButtonDisabled: false,
	  		serverMessage: "",
	  		emailfeedbackmsg: "",
	  		source:"plp",
	  		isOTPSend:false,
	  		isVerified:false,
	  		OTPDisabled:"hiddenOTP",
	  		verifyDisabled:"disabled",
	  		emailDisabled:false,
	  		phoneDisabled:false,
	  		verifyText:this.rb("mobile.submit"),
	  		sendOTPText:this.rb("register.sendOTP"),
	  		passcodeDisabled:"disabled"
          });
	  }
	  componentDidMount(){
	  	var me = this;
	  	this.sessionCheck();
	  } 

	  reinitiate(){		
	  	//console.log("reinitiate gaFrom:::::::::::",this.gaFrom);
	  	if(this.state.userInput != ""){
	  		this.form.validateFields();
	  		this.setState({ submitButtonDisabled: !this.form.isValid() });
	  		if(this.form.isValid()){
	  			this.setState({ OTPDisabled: ""});			
	  			$(".OTPButton").trigger("click");
	  		}
	  	}

	  	$("#loginRoot .userInput").focus();
	  }

	  handleChange(e) {
	  	const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}
	userIdChange(e){
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		if(phoneRegx.test(target.value)){
			this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			if(target.value.length >= 10){				
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}else{
			this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
			if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}
		
		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled:true
		});
		
	}
	
	enterOTPChange(e){
		if(this.otp.value.length > 0){
			this.setState({ verifyDisabled: ""});
		}else{
			this.setState({ verifyDisabled: "disabled"});
		}
		this.handleChange(e);
	}

	submitFormForPwd = function(){		
		var verificationtype = this.state.loginType;
		
		var formData = {		
				"userId":this.state.userInput,	
				"password":this.state.password_newacc
		}
		//do cofirm
		var me =this;
		me.setState({submitButtonDisabled: true});
		var callBackSuccess = function(response){				
			console.log("response : ", response);				
			if(response !== null){
				me.setState({submitButtonDisabled:false,validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});
				//console.log("timeout..........",me.state.pwdUpdated," : src = ",me.state.source);
				setTimeout(function(){
					console.log("timeout..........");
		  			me.bindLoginLink();
		  		},500);
				me.trackMe(true,"set_password");
				
			}else{
				me.trackMe(false,"set_password");
			}
		}

		var callBackFailure = function(response){
			me.setState({submitButtonDisabled: false});
			me.trackMe(false,"set_password");
		}

		new HmAjax(this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);
	}
	
	trackMe(result,source){			
		// var trackObj = {
		// 	"name": this.state.username_newacc,
		// 	"email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
		// 	"phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
		// 	"event_source":this.getTracker().enums.signupEventSource[source],
		// 	"result": result

		// }
		
		// if(source == "set_password") {
		// 	this.storeTrackEvent("signup", trackObj);
		// } else {
		// 	this.initiateTrack("signup",trackObj);
		// }
	}

	handleSubmitForPwd = (e) => {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   

			if(this.state.isOTPSend && this.state.isVerified){
				this.submitFormForPwd();    
			}
		}
	}

	sendOTPForPWDReset = () => {		
		// if(this.state.OTPDisabled == "hiddenOTP"){
		// 	this.form.validateFields();
		// 	return;
		// }
		
		var me =this;
		var otpServerMsg = "";
		
		if(this.state.loginType == "mobile"){
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to mobile";
			}else{
				otpServerMsg = "OTP is sent to your mobile";
			}
		}else{
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to your email";
			}else{
				otpServerMsg = "OTP is sent to your email";
			}
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});
				
		var formData = {
				"userId":this.state.userInput,				
				"contactType":this.state.loginType
		}		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",passcodeDisabled:""});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});
					}else if(response.status == "INVALID_EMAIL"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "INVALID_USERID"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "PROVIDER_FORBIDDEN"){
						me.setState({serverMessage: me.rb("google.errmsg.pwd"),passcodeDisabled:""});
					}
					else{
						me.setState({emailfeedbackmsg:otpServerMsg});
					}					
				}
				
				if(response.status.toLowerCase() == "success"){
					me.setState({isOTPSend:true,passcodeDisabled:"disabled"});
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}
						
			}

			console.log("response : ", response);
		}

		var PLPcallBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			me.setState({passcodeDisabled:""});
			me.trackMe(false,"send_otp");
		}

		var callBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			//me.setState({passcodeDisabled:""});
			//me.trackMe(false,"send_otp");
			new NativeAjax(me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}
		

		//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, callBackFailure);
    }
    
	getOTPField(){
		if(this.state.isOTPSend){
			let plp_userinput = this.props.userInput;

			return(
				<FormGroup for="otp_newacc">
				<FormControlInput type="number" className="otp_newacc" name="otp_newacc" placeholder=""	
				innerRef={otp => this.otp = otp}
				onKeyUp={this.handleKeyUp}
				value={this.state.otp_newacc} onChange={this.enterOTPChange}
				required minLength={1} maxLength={6} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
				<FieldFeedbacks for="otp_newacc">
				<FieldFeedback when="valueMissing">{this.rb("register.enterOTP")}</FieldFeedback>
				<FieldFeedback when="*" />
				</FieldFeedbacks>
				</FormGroup>
				);
		}
    }
    
    revealPasswordFn = () => {
		let passwordType = (this.state.passwordType ==="password") ?  "text" : "password";
        this.setState({passwordType:passwordType});
    }

    revealConformPasswordFn = () => {
        let confirmPasswordType = (this.state.confirmPasswordType ==="password") ?  "text" : "password";
        this.setState({confirmPasswordType:confirmPasswordType});
    }

bindLoginLink = () => {
	
	this.setState({resetSuccess:true});
}


resetSuccessPage = () => {
	let me=this;
	if(this.state.resetSuccess){
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		return(
			<div className="row otpMob">
						<div className="col-sm-12 nopadding mob-banner">
						<div className="backbtn" onClick={me.backFn}><img src={'img/remedialMobile/icons/arrow.png'}></img></div>
		<h1 className="otp-title">{this.getTextForOTP()}</h1>
						</div>
		
						<div id="otpMobile" className="remedialLogin col-sm-12 successpage">
		
							<div className="container">
		
										<div className="row">
											<div className="col-md-12 mx-auto nopadding">
												<div className="rounded-0">
													<div className="text-center ">
													   
													<button data-ga={"Home - " + me.gaFrom + me.gasignin + "  - Sign In"} disabled={me.state.submitButtonDisabled} className={"submitButton verifyButton"+submitbtnAddCls} onClick={this.backFn}>Login Now</button>

													</div>
												</div>
											</div>
		
		
										</div>
		
									</div>
								</div>
							</div>
					
			)
	}
}

setNewPassword = () => {
		if(this.state.isVerified){
			let passwordIcon = this.state.passwordType === "password" ? 'img/remedialMobile/icons/icons_invisible.png' : 'img/remedialMobile/icons/icons_visible.png';
			let confirmpasswordIcon = this.state.confirmPasswordType === "password" ? 'img/remedialMobile/icons/icons_invisible.png' : 'img/remedialMobile/icons/icons_visible.png';
			let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
			return(
				<div>					
					<FormGroup for="password_newacc">
                        <span className="inputLabel">Enter New Password</span>
						<div className="pwd-icon" onClick={this.revealPasswordFn}><img src={passwordIcon}></img></div>
						<FormControlInput type={this.state.passwordType} className="password_newacc" name="password_newacc" placeholder={this.rb("login.password")}						
						innerRef={password => this.password = password}
						value={this.state.password_newacc} onChange={this.handleChange}
						required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
						<FieldFeedbacks for="password_newacc">
						<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
						<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
						</FieldFeedbacks>
					</FormGroup>
					
					<FormGroup for="confirmpassword">
                         <span className="inputLabel">Confirm New Password</span>
						 <div className="confirmpwd-icon" onClick={this.revealConformPasswordFn}><img src={confirmpasswordIcon}></img></div>
						<FormControlInput type={this.state.confirmPasswordType} className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
							innerRef={confirmpassword => this.confirmpassword = confirmpassword}
						value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
						required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />
						
						<FieldFeedbacks for="confirmpassword_newacc">
							<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
							<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
							<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
						</FieldFeedbacks>					
					</FormGroup>
					
					<div className="clear clearfix"></div>
				
					<div className="server-messages pt-20">{this.state.serverMessage}</div>
					<button data-ga={"Home - Users who have independently registered - Sign Up - New User - Start Learning"} disabled={this.state.submitButtonDisabled} className={"submitButton signup signupButton "+submitbtnAddCls}>Submit</button>
				</div>
			);
		}
}

handleKeyUp(event) {
	if (event.key === 'Enter' && this.form.isValid()) {	    	
		if(!this.state.isVerified){
			if(this.state.isOTPSend && this.state.verifyDisabled != "disabled"){
				$(".verifyButton").trigger("click");
			}else if(this.state.passcodeDisabled != "disabled"){
				this.setState({ OTPDisabled: ""});
				$(".OTPButton").trigger("click");				
			}
		}

	}
}

    
    backFn = () => {
        if(typeof this.props.backFn === "function"){
            this.props.backFn()
        }
	}
	
	getTextForOTP = () => {
		let callFrom = this.props.callFrom;
		if(callFrom === "forgotPWD" && this.state.resetSuccess){
			return "Congrats, You have successfully reset your password"
		}else if(callFrom === "forgotPWD"){
			return "Reset Password here"
		}else{
			return "Looks like you are new here"
		}
	}

	getVerifyField(){
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		if(this.state.isOTPSend && !this.state.isVerified){
			return (<div className={"submitButton verifyButton "+submitbtnAddCls+" "+this.state.verifyDisabled} onClick={this.verifyOTPForPWDReset} >{this.rb("mobile.submit")}</div>);
		}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/
		
	}

	checkForDisabled(){
		return true;
	}

	getUserInputPattern(){		
		if(this.state.loginType == "mobile"){
			return ".{10,}";
		}else{
			return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
		}
	}

	getContactType(){
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
        //console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
		if(!this.state.isVerified){
			return(
				<div>
					{(()=>{
								if(!this.state.isOTPSend){
									return(
										<div className="small infogrey mt-10 textAlignLeft">{this.rb("unifiedlogin.otpalert")}{this.state.loginType == "mobile" ? "mobile no":"email"}</div>
									)
								}
							})()}
					<FormGroup for="userInput">
					{(() => {
																if (this.state.loginType == "mobile") {
																	return (
																		<span className="countrycode">+91</span>
																	);
																}
							})()} 
						<FormControlInput type="userInput" className={"userInput "+this.state.loginType} name="userInput" placeholder={this.rb("mobile.login.userplaceholder")}
							innerRef={email => this.email = email}
							onKeyUp={this.handleKeyUp}
							value={this.state.userInput} onChange={this.userIdChange} disabled={this.checkForDisabled()}
							pattern={this.getUserInputPattern()}
							required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
							
						
							<FieldFeedbacks for="userInput">
								<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
								<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
									<FieldFeedback when={value => (value.length>0 && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
								<FieldFeedback when="*" />
							</FieldFeedbacks>

					</FormGroup>
					
					<div className="clear clearfix"></div>
					
					{this.getOTPField()}				
							
					<div className="clear clearfix"></div>
				
					<div className="server-messages pb-20">{this.state.serverMessage}</div>
										
					
					{( () => {
						
							if(this.state.isOTPSend){
								return(
								<div>									
									<div className="clearfix">
										<span>{this.rb("register.reSendOTPmsg")} </span> <span className="pl-10 resendButton" onClick={this.sendOTPForPWDReset}>{this.rb("register.reSendOTP")}</span>
									</div>
									{this.getVerifyField()}
								</div>
								);
							}else{
								return(
									<div>
										{this.getVerifyField()}
										<div>
										<div className={"submitButton OTPButton "+submitbtnAddCls+" "+this.state.OTPDisabled} onClick={this.sendOTPForPWDReset} >{this.rb("mobile.home.continue")}</div>
										</div>
									</div>
								);
							}
						
					})()}
				</div>
			);
		}
	}

	verifyOTPForPWDReset = () => {
		var me =this;
		var formData = {
				"userId":this.state.userInput
		}
		
		me.setState({serverMessage:""});
		var verificationtype = this.state.loginType;
		this.setState({verifyDisabled:"disabled"});	
		var callBackSuccess = function(response){
			if(response !== null){
				
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "no_such_token" || response.status == "NO_TOKEN_AVAILABLE"){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.isValid == false){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}
					else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else{
						me.setState({isVerified:true,verifyDisabled: ""});
						me.trackMe(true,"verify_otp");
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in PWD_TOKEN_VALIDATE");	
			me.setState({verifyDisabled:""});
			me.trackMe(false,"verify_otp");
		}

		new HmAjax((this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc),formData).post(callBackSuccess,callBackFailure);
    }
    
    getPasswordText = () => {
        if(this.state.isVerified){
            return "Create New Password";
        }else{
            return "Reset Password here";
        }
    }
	
	mobileForgotPWDUIOTP = () => {
        let loginType = this.props.loginType;
        let from = this.props.from;
        let plp_userinput = this.props.userInput;
		let me=this;
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		//console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
		let callFrom  = this.props.callFrom;
		if(!this.state.resetSuccess && callFrom === "forgotPWD"){
			//console.log("getContactType ",this.state.isOTPSend);
			return (
				<div className="row otpMob">
                <div className="col-sm-12 nopadding mob-banner">
				<div className="backbtn" onClick={me.backFn}><img src={'img/remedialMobile/icons/arrow.png'}></img></div>
                    <h1 className="otp-title">{this.getPasswordText()}</h1>
					</div>
					<div id="otpMobile" className="remedialLogin col-sm-12">
					<div className="container">

				<div className="row">
					<div className="col-md-12 mx-auto nopadding">
						<div className="rounded-0">
						
							<div className="">
									<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
										onSubmit={this.handleSubmitForPwd} noValidate>
									{this.getContactType()}
									{this.setNewPassword()}	
									
									</FormWithConstraints>
									</div>
								</div>
				</div>
				</div>
				</div>
				</div>
				</div>
			)
		}
    }
    
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { 
			
			return (
			
		<div className="col-12 nomargin loginParent mobileforgotPWD">

		{this.mobileForgotPWDUIOTP()}

		{this.resetSuccessPage()}

		</div>
		);}
	}
}

export default MobileForgotPWD;


// WEBPACK FOOTER //
// ./src/views/login/MobileForgotPwd.js